// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".forgot-username-form .nav-link{padding:0}.forgot-username-form button{display:inline-block}.forgot-username-form .invalid-feedback,.forgot-username-form a{color:#fff}", ""]);
// Exports
module.exports = exports;
